/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Civilization, unit type
 */
export interface CivUnitAction { 
    /**
     * Civilization name
     */
    civilizationName: string;
    /**
     * Type of unit
     */
    type: CivUnitAction.TypeEnum;
}
export namespace CivUnitAction {
    export type TypeEnum = 'Infantry' | 'Mounted' | 'Artillery' | 'Aircraft';
    export const TypeEnum = {
        Infantry: 'Infantry' as TypeEnum,
        Mounted: 'Mounted' as TypeEnum,
        Artillery: 'Artillery' as TypeEnum,
        Aircraft: 'Aircraft' as TypeEnum
    };
}